// api/adminApi.js - Shared API layer for Masters (Admins) & Users
import axios from 'axios';
import { API_BASE, getHeaders } from '../../config/api';    

const BASE_URL = `${API_BASE}/api/superAdmin/userDocs`;

// Pulls the bearer token from wherever your app stores it after login.
// Adjust this to match your auth flow (redux store, context, cookies, etc).
const getToken = () => sessionStorage.getItem('adminToken') || sessionStorage.getItem('subAdminToken') || '';

const client = axios.create({
    baseURL: BASE_URL,
    headers: getHeaders(),
});

client.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// ── Masters (Admins) ────────────────────────────────────────────────────────
// Note: backend expects GET with a JSON body for status filtering, which the
// fetch spec disallows on GET — axios supports it via the `data` config key.
export const getAllMasters = async (status) => {
    const config =
        status && status !== 'all'
            ? { data: { status } }
            : {};

    const { data } = await client.request({
        url: '/getall-masters',
        method: 'POST',
        ...config,
    });

    return data; // { success, message, masters, masterExcell }
};

export const getMasterById = async (masterId) => {
    const { data } = await client.post(
        '/get-master-by-id',
        {
            masterId,
        }
    );

    return data; // { success, message, master }
};

export const updateMasterStatus = async (adminId, status) => {
    const { data } = await client.put('/update-master-status', { adminId, status });
    return data;
};

export const getAllUsers = async (status) => {
    const { data } = await client.request({
        url: '/getall-users',
        method: 'POST',
        data: status && status !== 'all'
            ? { status }
            : {},
    });

    return data;
};

export const getUserById = async (userId) => {
    const { data } = await client.post(
        '/get-user-by-id',
        {
            userId,
        }
    );

    return data; // { success, message, user }
};

export const updateUserStatus = async (userId, status) => {
    const { data } = await client.put('/update-user-status', { userId, status });
    return data;
};

export default {
    getAllMasters,
    getMasterById,
    updateMasterStatus,
    getAllUsers,
    getUserById,
    updateUserStatus
};